import React, { Component } from "react";

export default class EmployeeDetailItemsContainer extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
          alignItems: "flex-start",
          paddingLeft: 10,
          paddingRight: 10,
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
